import {CRUD} from './base/crud';
import {User} from "@/model/api/User";
import {plainToClass} from "class-transformer";

class WhitelistUsersService extends CRUD<User, any> {
    readonly endPoint = `shift-whitelist`;

    whitelistedUsers: User[] = []

    public async removeUser(item: any): Promise<User> {
        if (item.shift_id) {
            await this.delete<User>(`${this.endPoint}`, item);
        }
        this.whitelistedUsers = this.whitelistedUsers.filter((wUser) => wUser.id !== item.broker_id)
        return
    }

    public async editUser({shift_id, broker}): Promise<User[]> {
        return await this.patch<any>(`${this.endPoint}`, {
                shift_id,
                broker_id: broker.id,
                trucks_required: broker.trucks_required
        });
    }

    public async addUser({shift_id, broker}): Promise<User> {
        let plainUser
        if (shift_id) {
            plainUser = await this.post<User>(`${this.endPoint}`, {
                shift_id,
                broker_id: broker.id,
                trucks_required: broker.trucks_required
            });
        } else {
            plainUser = plainToClass(User, broker)
        }
        if (!this.whitelistedUsers.find((user) => user.id === plainUser.id)) {
            this.whitelistedUsers.push(plainUser)
        }
        return plainUser
    }

    public clearUsers() {
        this.whitelistedUsers = []
    }

    public async getUsers(params?: any, force: boolean = false): Promise<User[]> {
        if ((!this.whitelistedUsers.length || force) && params) {
            const users = await this.get<User[]>(`${this.endPoint}?shift_id=${params.shift_id}`);
            this.whitelistedUsers = plainToClass(User, users)
        }
        return this.whitelistedUsers;
    }

}

export const whitelistUsersService = new WhitelistUsersService();



